import React from 'react';
import { Star } from 'lucide-react';
interface TestimonialCardProps {
  name: string;
  age: number;
  city: string;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote
}: TestimonialCardProps) {
  return <div className="bg-zinc-900 border border-zinc-800 p-6 rounded-xl flex flex-col gap-4" data-id="element-121">
      <div className="flex text-[#F59E0B]" data-id="element-122">
        {[...Array(5)].map((_, i) => <Star key={i} size={20} fill="currentColor" data-id="element-123" />)}
      </div>
      <p className="text-zinc-300 italic text-lg leading-relaxed" data-id="element-124">"{quote}"</p>
      <div className="mt-auto pt-4 border-t border-zinc-800" data-id="element-125">
        <p className="font-bold text-white" data-id="element-126">
          {name}, {age} años
        </p>
        <p className="text-sm text-zinc-500" data-id="element-127">{city}</p>
      </div>
    </div>;
}